import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=04b42650&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=04b42650&prod&lang=less&scoped=true"
import style1 from "./Home.vue?vue&type=style&index=1&id=04b42650&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b42650",
  null
  
)

export default component.exports